import { forwardRef, ReactNode } from 'react';
import { Button, ButtonProps } from './Button';

export interface IconButtonProps extends Omit<ButtonProps, 'icon' | 'children' | 'iconOnly' | 'aria-label'> {
    /** Required: the button has no visible text. */
    'aria-label': string;
    children: ReactNode;
}

/** Square icon button, 44 px by default. Pass the icon as children (20 px, aria-hidden). */
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
    { variant = 'quiet', ...rest },
    ref
) {
    return <Button ref={ref} variant={variant} iconOnly {...rest} />;
});
